
import {Vue, Component, Emit, Prop} from 'vue-property-decorator';
import {userApi, classesApi} from '@/api';
import UserInfoEdit from '@/components/Modal/UserInfoEdit.vue';

import moment from 'moment';
import {getDomainHandle, isLocal} from '@/js/domainUtils';

@Component({
    components: {
        UserInfoEdit
    }
})
export default class Top extends Vue {
    //===================================data区域begin
    logoImg = getDomainHandle('logoUrl');
    name: string = '';
    user: any = {};
    pageData: any = {
        helpList: [],
        labPlatformList: []
    };
    // 学校名称
    orgName: string = '';
    showUserInfo: boolean = false;
    //===================================data区域end

    //===================================prop区域begin
    //主题
    @Prop({default: 'white'}) themeMode?: string;
    //是否显示首页
    @Prop({default: true}) showHome?: boolean;
    //是否显示导航
    @Prop({default: true}) showNavigationTitle?: boolean;
    //导航部分的内容
    @Prop({default: ''}) navigationTitle?: string;
    //是否要求登录：不要求登录，与登录相关的数据将全部不显示，与登录相关的请求不执行
    @Prop({default: true}) requireLogin?: boolean;
    //是否显示个人中心
    @Prop({default: true}) showUserCenter?: boolean;
    //===================================prop区域end

    //===================================computed区域begin
    get isShowUserCenter(): boolean {
        return this.showUserCenter && this.user && this.user.username !== undefined;
    }
    get isTeacher(): boolean {
        return this.user.roles?.includes('teacher');
    }
    get usedDay(): number {
        const createAt = this.$app.getState().createdAt;
        if (!createAt) return 0;
        const now = new Date().getTime();
        return Math.ceil((now - createAt) / (24 * 3600 * 1000));
    }
    get expireTime(): string {
        let endTime = moment(this.user.expireTime).format('YYYY/MM/DD');
        return endTime;
    }
    //===================================computed区域end

    //===================================methods区域begin
    //获取学校信息
    initOrganization() {
        let me = this;
        classesApi.getSchoolById({
            context: this,
            urlParamObj: {
                id: me.user.schoolId
            },
            success(data: any, parameters: any) {
                let domain = data.data;
                domain.validStartTime = moment(domain.validStartTime).format('YYYY/MM/DD');
                domain.expireTime = moment(domain.expireTime).format('YYYY/MM/DD');
                window.localStorage.setItem('schoolInfo', JSON.stringify(domain));
                me.orgName = domain.name;
            },
            error(error: any, message: string, parameters: any) {
                me.$message.error(message);
            }
        });
    }
    handleLogoClick(): void {
        console.log('......');
    }
    showInfoEdit() {
        this.showUserInfo = true;
    }
    handleLabPlatformClick(item: any): void {
        let platform = item.value;
        if (platform === '4') {
            //--打开labNotebook
            let url = '/public/mbyte';
            window.open(url);
        } else {
            let url = item.extend2;
            let user = this.$app.getState();
            if (user && user.loginToken) {
                console.log('用户已登录并且找到loginToken');
                url = this.$basicRequest.appendUrlParameter(url, {
                    loginToken: encodeURIComponent(user.loginToken)
                });
            }
            window.open(url); //,"new-window-lab");
        }
    }
    handleHelpeClick(item: any): void {
        let me = this;
        window.open(item.extend2, 'help-drive-download');
    }
    // 1.18.0版帮助中心
    toHelp() {
        window.open('/docs/');
    }
    handleLogoutClick(item: any): void {
        let me = this;
        this.$confirm({
            title: '提示',
            content: '是否退出登录?',
            onOk() {
                me.logout();
            },
            onCancel() {
                console.log('Cancel');
            }
        });
    }
    goTeaching() {
        let me = this;
        let host = location.host;
        userApi.getTicket({
            context: me,
            data:{
                 target: 'aicp-teacher-web'
            },
            success: (data: any) => {
                const domainKey = getDomainHandle('key');
                let host = location.host;
                if (isLocal()) {
                    window.open(`http://localhost:8088/Login?loginToken=${data.data}`, 'teaching');
                } else if (host.includes('dev')) {
                    window.open(`https://${domainKey}-teacher-web.dev.dm-ai.com/Login?loginToken=${data.data}`, 'teaching');
                } else if (host.includes('stage')) {
                    window.open(`https://${domainKey}-teacher-web.stage.dm-ai.com/Login?loginToken=${data.data}`, 'teaching');
                } else if (host.includes('partner')) {
                    window.open(`https://${domainKey}-teacher-web.partner.dm-ai.com/Login?loginToken=${data.data}`, 'teaching');
                } else if (host.includes('pet')) {
                    window.open(`https://${domainKey}-teacher-web.pet.dm-ai.com/Login?loginToken=${data.data}`, 'teaching');
                } else {
                    window.open(`https://${domainKey}-teacher-web.dm-ai.com/Login?loginToken=${data.data}`, 'teaching');
                }
                // resolve(`http://localhost:8088/Login?loginToken=${data.data}`);
            }
        });
    }
    goTeachingResearch() {
        let me = this;
        userApi.getTicket({
            context: me,
            success: (data: any) => {
                const domainKey = getDomainHandle('key');
                let host = location.host;
                if (isLocal()) {
                    window.open(`http://localhost:9000/Login?loginToken=${data.data}`, 'teacherResearch');
                } else if (host.includes('dev')) {
                    window.open(
                        `https://${domainKey}-teaching-research-web.dev.dm-ai.com/Login?loginToken=${data.data}`,
                        'teacherResearch'
                    );
                } else if (host.includes('stage')) {
                    window.open(
                        `https://${domainKey}-teaching-research-web.stage.dm-ai.com/Login?loginToken=${data.data}`,
                        'teacherResearch'
                    );
                } else if (host.includes('partner')) {
                    window.open(
                        `https://${domainKey}-teaching-research-web.partner.dm-ai.com/Login?loginToken=${data.data}`,
                        'teacherResearch'
                    );
                }else if (host.includes('pet')) {
                    window.open(
                        `https://${domainKey}-teaching-research-web.pet.dm-ai.com/Login?loginToken=${data.data}`,
                        'teacherResearch'
                    );
                } else {
                    window.open(`https://${domainKey}-teaching-research-web.dm-ai.com/Login?loginToken=${data.data}`, 'teacherResearch');
                }
                // resolve(`http://localhost:9000/Login?loginToken=${data.data}`);
            }
        });
    }
    logout() {
        let me = this;
        userApi.logout({
            context: me,
            success(data: any, parameters: any) {
                me.$message.success('退出登录成功');
                me.$app.localLogout(me, true);
                localStorage.removeItem('frequencyData');
                localStorage.removeItem('schoolInfo');
                localStorage.removeItem('classInfo');
            },
            error(data: any, message: any, parameters: any) {
                me.$message.error(message);
            }
        });
    }
    //===================================methods区域end

    created() {
        let domain = this.$app.getState();
        if (domain) {
            this.user = domain;
        }
        if (this.user.schoolId) {
            this.initOrganization();
        }
        // console.log(this.user);
    }
}
